<template>
  <div>
    <nav
      class="navbar flex-nowrap nav-menu"
      v-bind:class="[{'d-none':$parent.isHideSearch, 'navbar-desktop': is_desktop}]"
      exclude
    >
      <!--  -->
      <div class="d-flex flex-grow-1">
        <vs-button
          v-if="($route.path === '/' || (is_desktop && ($parent.event_selected || ['/searchroute','/route','/landmarkpoi','/place'].includes($route.path) || ['SharedRoute','EventDetail','MapTripList','BusTrip','Search'].includes($route.name))))"
          color="primary"
          class="main-menu"
          @click="$parent.openSlide"
          style="width: 48px;"
        >
          <img
            class="menu"
            :src="$parent.icon.menu_icon"
            style="width: 20px; cursor: pointer; margin: 0 2px;"
          >
        </vs-button>
        <vs-button
          v-else
          color="primary"
          class="main-menu"
          @click="$parent.goBack(['/searchroute','/route','/landmarkpoi','/place'].includes($route.path) || ['SharedRoute','EventDetail','MapTripList','BusTrip','Search'].includes($route.name))"
          style="width: 48px;"
        >
          <img
            class="menu"
            :src="$parent.icon.back_alt_icon"
            style="width:25px; margin: 0 1px 2px 0;"
          >
        </vs-button>
        <div
          class="pin-color p-0 pl-1 position-relative flex-grow-1"
          v-bind:class="{'d-none':is_desktop}"
        >
          <div class="vertical-divider mx-2" style="height: 36px;position: absolute;right: 40px;top: 7px;border-color: #EAEAEA;" />
          <vs-button
            color="#FFF" type="filled"
            class="btn-input-direction p-0"
            v-on:click="goSearch"
          >
            <img
              height="25"
              :src="$parent.icon.bus_icon_blue"
              class="position-relative"
            >
          </vs-button>
          <input
            class="form-control box-round"
            v-bind:placeholder="$t('message.msg_search')"
            v-on:click="goSearchRoute"
            style="height: 48px;"
          >
        </div>

        <div v-if="is_desktop" class="vertical-divider" style="height: 31px; margin-right: 24px;"></div>

        <div
          class="text-left account-desktop p-0 cursor"
          v-on:click="$router.replace('/')"
        >
          <img
            height="30"
            :src="icon.menu_logo_icon"
          >
        </div>
      </div>

      <template v-if="!$parent.isNoLogin">
        <div
          class="pl-0 account-desktop text-right"
          v-on:click="$parent.openSlide"
          v-if="$parent.is_login"
        >
          <div
            class="user-box cursor mr-1"
          >
            <img
              v-if="$parent.profile_picture != null && $parent.profile_picture != ''"
              height="30"
              :src="$parent.profile_picture"
              class="avatar"
            >
            <img
              v-else
              height="30"
              :src="$parent.icon.user_icon"
            >
            <a
              v-if="$parent.fullname"
              href="#"
              class="primary--text mx-3"
            >
              {{ $parent.fullname }}
            </a>
            <a
              v-else
              href="#"
              class="primary--text mx-3"
            >
              ชื่อผู้ใช้งาน
            </a>
          </div>
        </div>
        <div
          class="pl-0 account-desktop text-right"
          v-else
        >
          <div
            class="user-box cursor mr-1"
            @click="goLogin"
          >
            <img
              v-if="$parent.profile_picture != null && $parent.profile_picture != ''"
              height="30"
              :src="$parent.profile_picture"
              class="avatar"
            >
            <img
              v-else
              height="30"
              :src="$parent.icon.user_icon"
            >
            <span class="primary--text mx-3">{{ $t('message.login.title') }}</span>
          </div>
        </div>
      </template>
    </nav>

    <div
      class="position-relative"
      v-bind:class="[{'d-none':($parent.isHideSearch || $route.path === '/searchroute' || $route.name === 'SharedRoute' || $route.path === '/route' || $route.path === '/bus') || ($parent.isOffline)}]"
    >
      <div
        v-bind:class="[{'search-desktop':is_desktop}]"
        class="inner-addon m-auto "
        style="position: absolute; "
      >
        <div class="vertical-divider mx-2" style="height: 36px;position: absolute;right: 40px;top: 7px;border-color: #EAEAEA;" />
        <vs-button
          color="#FFF" type="filled"
          class="btn-input-direction p-0"
          v-on:click="goSearch"
        >
          <img
            height="25"
            :src="$parent.icon.bus_icon_blue"
            class="position-relative"
          >
        </vs-button>
        <input
          class="form-control box-round"
          :maxlength="0"
          v-bind:placeholder="$t('message.msg_search')"
          v-on:click="goSearchRoute"
          style="height: 48px;"
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopBar',
  data () {
    return {
      is_desktop: this.$parent.isDesktop(),
      icon: {
        menu_logo_icon: require('@/assets/menu_logo.png'),
      }
    };
  },
  methods: {
    goLogin () {
      this.$parent.close()
      this.$router.push({ name: 'Login' })
    },
    goSearchRoute () {
      this.$parent.cache_routing = null
      this.$router.push({ name: 'SearchRoute' })
    },
    goSearch () {
      this.$router.push({ name: 'Search' })
    },
  }
};
</script>

<style lang="scss" scoped>
.vs-button {
  padding: 0;
}

.user-box {
  background: rgba(236, 242, 255, 0.85);
  padding: 6px 10px;
  border: 1px solid rgba(var(--vs-primary),1);
  border-radius: 6px;
  display: flex;
  align-items: center;
}

</style>
